<template>
    <div id="app" v-bind:class="{'thanks': isAgradecimento}">
        <div class="container" style="min-height: 100vh">

          <header v-if="!isAgradecimento">
            <picture>
              <source srcset="./assets/gm/bg-mobile.jpg" media="(max-width: 768px)">
              <img src="./assets/gm/bg-top.png"  class="img-fluid" alt="">
            </picture>
          </header>

          <div class="mobile-logo">
            <img src="./assets/gm/logo-mobile.png" class="d-inline-block d-md-none" alt="">
          </div>
          <!-- /.mobile-logo -->

          <div class="middle">
            <section class="cadastro" id="cadastro" v-show="!isAgradecimento && passo===1">
              <form ref="form" action="" class="form-lead" @submit="enviarLead">

                <input type="hidden" name="traffic_source">
                <input type="hidden" name="token_rdstation" value="bcae187412dcfb961aef5c1f6818c79b">
                <input type="hidden" name="identificador" value="lp-best-november">


                <div class="row align-items-center">
                  <div class="col-md-3">
                    <p>
                      Cadastre-se para descobrir
                      as ofertas antes de todo
                      mundo e ganhar até 50% off
                      <span>Para usar de 22 a 26 de novembro</span>
                    </p>
                  </div>
                  <!-- /.col-md-4 -->
                  <div class="col-md-9">
                    <div class="flexer">
                      <div class="form-group">
                        <!--                            <label for="nome">Nome</label>-->
                        <input id="nome" class="form-control" type="text" name="nome" required placeholder="Nome">
                      </div>
                      <!-- /.form-group -->
                      <div class="form-group">
                        <!--                            <label for="email">E-mail</label>-->
                        <input id="email" class="form-control" type="email" name="email" required placeholder="E-mail">
                      </div>
                      <!-- /.form-group -->

                      <div class="form-check" v-if="isMobile">
                        <input type="checkbox" name="termos" class="form-check-input" id="termos" required
                               value="">
                        <label class="form-check-label" for="termos">
                          Quero receber ofertas antes de todo mundo
                        </label>
                      </div>

                      <div class="form-group-">
                        <button class="btn btn-secondary btn-start">QUERO</button>
                        <!-- /.btn btn-secondary -->
                      </div>
                      <!-- /.form-group -->

                    </div>
                    <!-- /.flexer -->
                    <div class="form-check" v-if="!isMobile">
                      <input type="checkbox" name="termos" class="form-check-input" id="termos" required
                             value="">
                      <label class="form-check-label" for="termos">
                        Quero receber ofertas antes de todo mundo
                      </label>
                    </div>

                  </div>
                </div>
                <!-- /.row -->
              </form>
              <!-- /.form-lead -->
              <small>
                (*) Ao aceitar, estará ciente de que seus dados serão tratados com a finalidade exclusiva de envio de ações de marketing.
              </small>
            </section>
            <!-- /.cadastro -->

            <section class="quiz" v-show="!isAgradecimento && passo===2">
              <div class="row">
                <div class="col-12">
                  <h2>Perguntas quiz:</h2>
                  <div class="pergunta" v-for="pergunta in perguntas" :key="pergunta.id" v-show="indexPergunta===pergunta.id">

                    <div class="texto">
<!--                      <b>{{pergunta.id}})</b>-->
                      <span class="q">{{ pergunta.texto }}</span>

                      <ol class="choices" type="A" v-bind:class="{'done': pergunta.respostaCliente !== null}">
                        <li v-for="(item, index) in pergunta.opcoes" :key="item">
                          <a @click="responderPergunta(pergunta, index)" href="javascript:;">{{ item }}</a>
                          <span v-bind:class="{'correct': pergunta.respostaCliente !== null && index === pergunta.resposta}" class="qtip">RESPOSTA CORRETA</span>
                        </li>
                      </ol>
                      <!-- /.choices -->
                    </div>
                    <!-- /.texto -->

                    <div class="resposta" v-if="pergunta.respostaCliente != null">
                      <br>
                      {{ pergunta.explicacao }}

                      <div class="proxima">
                        <button @click="proximaPergunta" class="btn btn-success inverted">Próxima</button>
                      </div>
                      <!-- /.proxima -->
                    </div>
                    <!-- /.resposta -->

                  </div>
                  <!-- /.pergunta -->
                </div>
                <!-- /.col-12 -->
              </div>
              <!-- /.row -->
            </section>
            <!-- /.quiz -->

            <section class="obrigado" v-if="isAgradecimento">
              <div class="text">

                <div class="logo2-mobile d-inline-block d-md-none">
                  <img src="./assets/gm/logo2-mobile.png" alt="" class="img-fluid">
                </div>
                <!-- /.logo2-mobile -->

                <h2>
                  Cadastro Completo!
                  <span>
                    Você saiu na frente e agora tem acessos aos descontos da Best November em primeira mão. Clique no botão abaixo e garanta seu desconto

                  </span>
                </h2>

                <p>
                  <a href="https://www.vivagreenmix.com.br/promocoes/" target="_blank" class="btn btn-final">
                    MEUS DESCONTOS
                  </a> <br>
                  <!-- /.btn btn-final -->
                  Quer ficar por dentro de mais novidades e promoções exclusivas? Te esperamos lá no grupo do Telegram.

                  <a href="https://t.me/joinchat/KvCuiPEeAqJmMTA5" class="btn btn-final">
                    TÔ DENTRO!
                  </a>
                  <!-- /.btn btn-final -->
                </p>

              </div>
              <!-- /.text -->
            </section>
            <!-- /.obrigado -->


          </div>
          <!-- /.middle -->

          <div class="produtos" v-if="!isAgradecimento">

            <div class="titulo text-center">
              <img src="./assets/gm/ico-olha.png" alt="" class="img-fluid"> <br>
              Os best-sellers da vida saudável que estarão com preço inacreditável na Best November

            </div>
            <!-- /.titulo -->

            <div class="produto-item">
              <div class="p-img">
                <img class="img-fluid" src="./assets/gm/produto-supercoffee.png" alt="">
              </div>
              <!-- /.p-img -->
              <div class="produto-info">
                <h2>Supercoffee <span>Seu dia com mais energia e disposição</span></h2>
                <div class="desc">Um blend à base de café para acelerar a sua performance, foco e atividade cerebral.</div>
                <a @click="goToForm" href="#" class="btn">JÁ QUERO</a>
                <!-- /.btn btn-success -->
              </div>
              <!-- /.produto-info -->
            </div>
            <!-- /.produto-item -->

            <div class="produto-item">
              <div class="p-img">
                <img class="img-fluid" src="./assets/gm/produto-desincha.png" alt="">
              </div>
              <!-- /.p-img -->
              <div class="produto-info">
                <h2>Desinchá <span>O chá número 1 do Brasil</span></h2>
                <div class="desc">Desenvolvido por nutricionistas, a mistura perfeita e saborosa para começar seu dia com um hábito saudável.</div>
                <a @click="goToForm" href="#" class="btn">JÁ QUERO</a>
                <!-- /.btn btn-success -->
              </div>
              <!-- /.produto-info -->
            </div>
            <!-- /.produto-item -->

            <div class="produto-item">
              <div class="p-img">
                <img class="img-fluid" src="./assets/gm/produto-konjac.png" alt="">
              </div>
              <!-- /.p-img -->
              <div class="produto-info">
                <h2>Konjac <span>Mil possibilidades e apenas 9 calorias</span></h2>
                <div class="desc">Massas super versáteis (e zero sódio) que ajudam a aumentar a saciedade. Para você usar em receitas incríveis.</div>
                <a @click="goToForm" href="#" class="btn">JÁ QUERO</a>
                <!-- /.btn btn-success -->
              </div>
              <!-- /.produto-info -->
            </div>
            <!-- /.produto-item -->

            <div class="produto-item">
              <div class="p-img">
                <img class="img-fluid" src="./assets/gm/produto-doces.png" alt="">
              </div>
              <!-- /.p-img -->
              <div class="produto-info">
                <h2>Doces no pote Greenmix <span>Para matar a vontade de doce sem culpa</span></h2>
                <div class="desc">Nossa linha de doces artesanais sem lactose, super cremosos e sem nadinha de açúcar. </div>
                <a @click="goToForm" href="#" class="btn">JÁ QUERO</a>
                <!-- /.btn btn-success -->
              </div>
              <!-- /.produto-info -->
            </div>
            <!-- /.produto-item -->

          </div>
          <!-- /.produtos -->


            <footer>
                <div class="row align-items-center">
                    <div class="col-md-8 col-6">
                        <p>©2021 Greenmix.</p>
                    </div>
                    <!-- /.col-md-8 -->
                    <div class="col-md-4 col-6">
                        <div class="its-dare">
                          <span>Desenvolvido por </span>
                            <img src="./assets/gm/its-dare.svg" alt="Bold Comunicação">
                        </div>
                        <!-- /.its-dare -->
                    </div>
                    <!-- /.col-md-4 -->
                </div>
                <!-- /.row -->
            </footer>

        </div>
        <!-- /.container -->
    </div>
</template>

<script>
import $ from 'jquery';
import 'jquery-mask-plugin';
import sortBy from 'lodash/sortBy';
import 'select2';
import 'select2/dist/css/select2.css';
import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css'

let lerCookie = function (name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  data() {
    return {
      url_produto: 'https://www.pharmapele.com.br/imuno-caps-p297?utm_source=landingpage&utm_medium=cpa&utm_campaign=imunocaps_bbb',
      passo: 1,
      email: '',
      indexPergunta: 1, // TODO fix this
      respostas: {},
      perguntas: [
        {
          id: 1,
          texto: 'Qual o nome da nossa super natural chef?',
          resposta: 0,
          respostaCliente: null,
          explicacao: '',
          opcoes: [
            'Mari Dias', 'Mara Dias', 'Bruna Dia'
          ]

        },
        {
          id: 2,
          texto: 'Qual é a sobremesa saudável mais amada por aqui?',
          resposta: 1,
          respostaCliente: null,
          explicacao: '',
          opcoes:[
            'Banana Split', 'Waffle', 'Pudim'
          ]

        },
        {
          id: 3,
          texto: 'Em que cidade ficam as nossas lojas?',
          resposta: 1,
          respostaCliente: null,
          explicacao: '',
          opcoes: [
            'Belém', 'Recife', 'Porto Alegre'
          ]

        },
        {
          id: 4,
          texto: 'Quais são as cores da nossa marca?',
          resposta: 0,
          respostaCliente: null,
          explicacao: '',
          opcoes: [
            'Verde e roxo', 'Preto e branco', 'Amarelo e vermelho'
          ]

        },
        {
          id: 5,
          texto: 'Nos domingos, é possível curtir no nosso jardim da Zona Norte…',
          resposta: 2,
          respostaCliente: null,
          explicacao: '',
          opcoes: [
            'Atrações de circo', 'Desfile de moda', 'Café da manhã e música ao vivo'
          ]
        }
      ]
    }
  },
  computed: {
    isAgradecimento() {
      // return true
      return this.indexPergunta > this.perguntas.length;
    },
    respostasValidas() {
      return this.perguntas.filter((p) => {
        return p.resposta === p.respostaCliente;
      }).length;
    },
    isMobile(){
      return window.matchMedia('(max-width: 768px)').matches;
    }
  },
  mounted() {
    $('[data-mask]').each(function () {
      $(this).mask($(this).attr('data-mask'), {clearIfNotMatch: true});
    });

    $("#scrolll").click(function () {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#cadastro").offset().top
      }, 1000);
    });


    $('[data-ibge-estados]').change(function () {
      let selectCidades = document.querySelector('[data-ibge-cidades]');
      let el = $(this);
      let idEstado = el.find('option:selected').attr('data-id');

      let apiUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + idEstado + '/distritos';

      $.get(apiUrl, function (res) {

        res = sortBy(res, ['nome']);

        let fragment = document.createDocumentFragment();
        let firstOption = document.createElement('option');
        firstOption.innerHTML = 'Selecione';
        firstOption.setAttribute('value', '');
        fragment.appendChild(firstOption);

        res.forEach(function (cidade) {
          let option = document.createElement('option');
          option.innerHTML = cidade.nome;
          fragment.appendChild(option);
        });

        selectCidades.innerHTML = '';
        selectCidades.appendChild(fragment);
        $(selectCidades).select2({
          theme: 'bootstrap4',
          placeholder: 'Selecione'
        });

      })
    });

    setTimeout(() => {
      $('select[name=estado], select[name=cidade]').select2({
        theme: 'bootstrap4',
        placeholder: 'Selecione'
      });
    }, 100)
  },
  methods: {
    goToForm(e){
      e.preventDefault()
      this.$refs.form.scrollIntoView({  behavior: 'smooth'})

    },
    enviarConversaoRD(identificador) {

      let params = {
        'email': this.email,
        'token_rdstation': $('.form-lead input[name=token_rdstation]').val(),
        'identificador': identificador,
        'traffic_source': lerCookie('__trf.src')
      }

      $.post('https://www.rdstation.com.br/api/1.3/conversions', params);
    },
    enviarLead(e) {
      e.preventDefault();
      //todo enviar lead

      // envia os dados para o rdstation

      this.email = $('.form-lead input[name=email]').val();

      let form = $('.form-lead');

      form.find('input[name="traffic_source"]').val(lerCookie('__trf.src'));

      const formData = form.serializeArray();

      let formJson = formData.reduce((acc,item) => {
        acc[item.name] = item.value
        return acc;
      }, {});

      formJson.legal_bases = [
        {
          "category": "communications",
          "type": "consent",
          "status": "granted"
        }
      ]

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'event': 'lp-best-november'});

      $.ajax({
        type: 'POST',
        url: 'https://www.rdstation.com.br/api/1.3/conversions',
        data: JSON.stringify(formJson),
        contentType: "application/json",
        dataType: 'json'
      }).fail(() => {
        alert('Não foi possível processar sua solicitação, tente mais tarde.');
      }).done(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'lp-best-november'});
      });

      this.passo += 1;

    },
    proximaPergunta() {
      this.indexPergunta += 1;

      if (this.isAgradecimento) {
        this.enviarConversaoRD('lp-best-november-finalizou');
        window.dataLayer.push({'event': 'lp-best-november-finalizou'});

      }
    },
    responderPergunta(pergunta, resposta) {
      pergunta.respostaCliente = resposta;
    },
    toogleCard(e) {
      let card = $(e.target).closest('.card');
      // $('.dicas .card').removeClass('open');
      card.toggleClass('open');
    }

  }
}
</script>

<style lang="scss">
    @import "scss/app";
</style>
